export const home = {
  'seo.title': 'София и Елена — Нутрициология и Косметология | Двойная Экспертиза',
  'seo.description': 'Совместная работа двух экспертов-нутрициологов на стыке нутрициологии и косметологии. Восстановление гормонального фона, работа с ЖКТ, метаболизм и здоровье кожи.',
  'seo.keywords': 'нутрициолог, косметолог, здоровье, гормоны, ЖКТ, метаболизм, детская нутрициология, София, Елена',

  'hero.title': 'Система, в которой ваше тело\nнаконец-то зазвучит красиво',
  'hero.subtitle': 'Совместная работа двух экспертов на стыке нутрициологии и косметологии.\nМы не лечим симптомы — мы пересобираем ваше здоровье «по кирпичикам».',
  'hero.cta': 'Начать путь к себе',
  'hero.imageAlt': 'София и Елена — эксперты по нутрициологии и косметологии',
  'hero.ctaAria': 'Начать путь к здоровью',

  'whyTwo.title': 'Почему двое экспертов — это ваш результат ×10',
  'whyTwo.description': 'Пока один эксперт восстанавливает ваш гормональный фон и работу ЖКТ, второй — выстраивает ваш метаболизм, работает с дефицитами и заботится о том, чтобы ваша кожа сияла.',
  'whyTwo.quote': 'Вы получаете двойной контроль и глубокую экспертизу с двух сторон одновременно.',
  'whyTwo.imageAlt': 'Профессиональная консультация нутрициолога',
  'whyTwo.experts': 'Эксперта',
  'whyTwo.result': 'Результат',

  'philosophy.title': 'Бардак в голове = бардак в теле',
  'philosophy.belief': 'Мы не верим в диеты. Мы верим в знания.',
  'philosophy.description': 'Мы учим вас понимать сигналы своего тела, чтобы через 2 месяца вы стали сами себе лучшими нутрициологами.',

  'cta.title': 'Готовы перестать пробовать\nи начать получать результат?',
  'cta.primary': 'Выбрать программу',
  'cta.secondary': 'Бесплатная диагностика',
  'cta.primaryAria': 'Выбрать программу питания',
  'cta.secondaryAria': 'Записаться на бесплатную диагностику',
};